import slugify from 'slugify'
import { Gig, Skill } from '../types/gigs'
import { SkillGroup } from '../gigproApi/skillGroups'

export function getSlugFromSkill(skill: Skill | Gig['skill']) {
  return slugify(skill.name.replace('/', '-'), {
    lower: true,
    remove: /[*+~.()'"!:@]/g,
  })
}

export function getLabelForSkillGroup(skillGroup: SkillGroup) {
  return skillGroup.label ?? skillGroup.id
}
